import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const YAOS = {
    YANG: 'yang',
    YIN: 'yin'
};

const getFinalLineType = (yao) => {
    const isOriginalYang = yao === 7 || yao === 9;
    const isOriginalYin  = yao === 6 || yao === 8;
    const isMoving       = yao === 6 || yao === 9;
    const originalType   = isOriginalYang ? YAOS.YANG : YAOS.YIN;
    let changeType;
    if (isOriginalYang && isMoving)     changeType = YAOS.YIN;
    else if (isOriginalYin && isMoving) changeType = YAOS.YANG;
    else                                changeType = originalType;
    return { isMoving, originalType, changeType };
};

const SixYaoDisplay = ({ yaoResults, ganZhi, hexagramNames }) => {
    const { t } = useLanguage();

    if (!yaoResults || yaoResults.length !== 6) {
        return <div className="loading-message">{t('waitingForYao')}</div>;
    }

    const yaoDetails = yaoResults.map(getFinalLineType);

    // Yao position labels — rendered top (上爻) → bottom (初爻)
    const yaoPositions = t('yaoPositions') || ['初爻', '二爻', '三爻', '四爻', '五爻', '上爻'];
    const posLabelsTopDown = [
        yaoPositions[5], // 上爻
        yaoPositions[4], // 五爻
        yaoPositions[3], // 四爻
        yaoPositions[2], // 三爻
        yaoPositions[1], // 二爻
        yaoPositions[0], // 初爻
    ];

    const renderHexagram = (isMainHexagram) => {
        // Render from 上爻 (index 5) down to 初爻 (index 0)
        return yaoDetails.slice().reverse().map((data, index) => {
            const reversedIndex = yaoResults.length - 1 - index;
            const yaoPos   = posLabelsTopDown[index];
            const type     = isMainHexagram ? data.originalType : data.changeType;
            const isMoving = data.isMoving;

            // ○ = 老阳变爻, × = 老阴变爻 — shown only on 本卦
            const moveSymbol = isMainHexagram && isMoving
                ? (data.originalType === YAOS.YANG ? '○' : '×')
                : '';
            const moveClass = isMainHexagram && isMoving
                ? (data.originalType === YAOS.YANG ? 'yang-moving' : 'yin-moving')
                : 'no-symbol';

            // Divider between outer trigram (上/五/四) and inner trigram (三/二/初)
            const showDivider = index === 3;

            return (
                <React.Fragment key={reversedIndex}>
                    {showDivider && <div className="trigram-divider" />}
                    <div className="yao-row">
                        <div className="yao-position-name">{yaoPos}</div>
                        <div className={`yao-line ${type} ${isMoving ? 'is-moving' : ''}`}>
                            <div className="yao-line-main" />
                        </div>
                        <div className={`moving-symbol ${moveClass}`}>{moveSymbol}</div>
                    </div>
                </React.Fragment>
            );
        });
    };

    return (
        <div className="sixyao-display-card">
            {/* 干支信息 */}
            <div className="ganzhi-info">
                <p>
                    <span className="ganzhi-label">{t('divinationTime')}</span>
                    <span className="ganzhi-value">
                        {ganZhi.year} {ganZhi.month} {ganZhi.day} {ganZhi.time}
                    </span>
                </p>
            </div>

            {/* 本卦 + 变卦并排 */}
            <div className="hexagram-comparison">
                <div className="hexagram-column main-hexagram">
                    <div className="trigram-section-label outer-label">{t('outerTrigram')}</div>
                    <div className="yao-list-container">
                        {renderHexagram(true)}
                    </div>
                    <div className="trigram-section-label inner-label">{t('innerTrigram')}</div>
                    <h3 className="hexagram-title">
                        {t('mainHexagramLabel')}：{hexagramNames.main}
                    </h3>
                </div>

                <div className="hexagram-arrow">→</div>

                <div className="hexagram-column change-hexagram">
                    <div className="trigram-section-label outer-label">{t('outerTrigram')}</div>
                    <div className="yao-list-container">
                        {renderHexagram(false)}
                    </div>
                    <div className="trigram-section-label inner-label">{t('innerTrigram')}</div>
                    <h3 className="hexagram-title">
                        {t('changeHexagramLabel')}：{hexagramNames.change}
                    </h3>
                </div>
            </div>
        </div>
    );
};

export default SixYaoDisplay;
